import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { InputField, NotificationWarning, SolidButton } from '@noths/polaris-client-ribbons-design-system';
import * as tracking from "./tracking";
import * as styles from "./NewsletterSignUpForm.styles";
import { useCommunicationPreferences } from "../../../hooks/useCommunicationPreferences/useCommunicationPreferences";
var PRIVACY_URL = 'https://www.notonthehighstreet.com/about/privacy';
var isValidEmailAddress = function isValidEmailAddress(email) {
  var regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(String(email).toLowerCase());
};
export var NewsletterSignUpForm = function NewsletterSignUpForm(_ref) {
  var env = _ref.env;
  var _useCommunicationPref = useCommunicationPreferences(env),
    hasSignUpError = _useCommunicationPref.hasSignUpError,
    loading = _useCommunicationPref.loading,
    onSignUp = _useCommunicationPref.onSignUp;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    fieldError = _useState4[0],
    setFieldError = _useState4[1];
  var handleChange = function handleChange(evt) {
    return setValue(evt.currentTarget.value);
  };
  var handleSubmit = function handleSubmit(evt) {
    evt.preventDefault();
    setFieldError('');
    var email = value.trim();
    if (!email) {
      setFieldError('Email address is required');
      return;
    }
    if (!isValidEmailAddress(email)) {
      setFieldError('Email address is not valid');
      return;
    }
    onSignUp(email);
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_StyledForm, {
    noValidate: true,
    onSubmit: handleSubmit,
    $_css: styles.form
  }, /*#__PURE__*/React.createElement(_StyledH, {
    $_css2: styles.heading
  }, "Get first dibs"), /*#__PURE__*/React.createElement(_StyledP, {
    $_css3: styles.subHeading
  }, "Sign up for sales, discounts and small brand inspiration"), /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css4: styles.formButtons
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(InputField, {
    disabled: loading,
    error: fieldError,
    id: "newsletter-signup",
    label: "Newsletter signup",
    labelHidden: true,
    onChange: handleChange,
    placeholder: "Enter your email address",
    type: "email",
    value: value
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SolidButton, {
    disabled: loading,
    fullWidth: true,
    loading: loading
  }, "Subscribe"))), hasSignUpError && /*#__PURE__*/React.createElement(NotificationWarning, null, "Subscribing failed, try again later"), /*#__PURE__*/React.createElement(_StyledSmall, {
    $_css5: styles.privacyPolicy
  }, "See our\xA0", /*#__PURE__*/React.createElement(_StyledA, {
    href: PRIVACY_URL,
    onClick: tracking.sendPrivacyPolicySelectedEvent,
    $_css6: styles.privacyPolicy
  }, "privacy policy"), "\xA0to understand how we process your personal data to send you marketing emails")));
};
var _StyledForm = _styled("form")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledH = _styled2("h3")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledP = _styled3("p")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledDiv = _styled4("div")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css4;
});
var _StyledSmall = _styled5("small")(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css5;
});
var _StyledA = /*#__PURE__*/_styled6("a").withConfig({
  displayName: "NewsletterSignUpForm___StyledA",
  componentId: "sc-1uha9x9-0"
})(["", ""], function (p) {
  return p.$_css6;
});